// import uuid from "uuid/v4";
/* eslint-disable no-restricted-globals */
import addPropsToItem from '../../Components/FormBuilder/FormBuilderFunctions/addPropsToItem';
import {callPOST, callGET} from '../../Utils/ApiUtil';
import {placeActionButtons} from '../../Containers/LayoutContainer/LayoutCommonFunction';
import { 
  LAYOUT_SETTINGS,
  LAYOUT_FIELD_COUNT,
  ADD_ITEM_TO_PREVIEW, 
  REMOVE_ITEM_FROM_PREVIEW, 
  DRAG_ITEM_IN_PREVIEW,
  SHOW_EDITOR,
  HIDE_EDITOR,
  SUBMIT_EDITOR_STATE,
  ADD_FORM_TO_PREVIEW,
  ADD_SECTION_TO_PREVIEW,
  SET_FORM_CONTENT,
  DRAG_CONTENT_IN_PREVIEW,
  UPDATE_SECTION_HEAD,
  REMOVE_SECTION,
  LAYOUT_COLUMN_CHANGE,
  UPDATE_LAYOUT_ONCHANGE,
  SET_LAYOUT_DATA,
  ADD_REMOVE_ITEM_TO_QUICK_CREATE,
  HANDLE_INPUT_CHANGE,
  UPDATE_FORM_FIELD_VALIDATION,
  CLEAR_FORM_FIELD_VALIDATION,
  ADD_SELECTED_MULTILOOKUP,
  REMOVE_SELECTED_MULTILOOKUP,
  CLEAR_SELECTED_MULTILOOKUP,
  SET_SELECTED_MULTILOOKUP,
  DROPDOWN_FIELD_MAPPING,
  DETAILVIEW_ADD,
  DETAILVIEW_SORTING,
  DETAILVIEW_TYPE_HANDLER,
  SET_VALIDATION_RULES,
  SET_LAYOUT_RULES,
  FIELD_PERMISSION_ONCHANGE,
  MASTER_WINDOW_LIST_ACTION,
  UPDATE_ACTION_BUTTON,
  SET_SUBFORM_DATA,
  SET_LOOKUP_DEPENDENCY,
  UPDATE_DETAIL_VIEW_STATUS,
  ADD_REMOVE_ITEM_TO_MOBILE_VIEW,
  SET_LAYOUT_DATA_SUBFORM,
  SET_RULES_MAPPING,
  COPY_LAYOUT_FIELD_GROUPS,
  SET_MAPPING_TAGS,
  CLEAR_FIELD_GROUPS,
  SET_EMAIL_CONFIG_LIST,
  SET_USER_SELECTED_LIST,
  UPDATE_SUBFORM_FIELD_VALIDATION,
  ADD_INPROGRESS_STEP_EXECUTION,
  REMOVE_INPROGRESS_STEP_EXECUTION,  
  CLEAR_SUBFORM_FIELD_VALIDATION,
  ADD_COPY_SECTION_TO_LAYOUT,
  SET_ONLOAD_DATA_CONFIG,
  SET_ONCHANGE_DATA_CONFIG,
  HANDLE_INPUT_BLUR,
  UPDATE_SUBFORM_DATA,
  UPDATE_SECTION_SORT_BY,
  DETAILVIEW_SORT_BY_HANDLER,
  SET_ONCHANGE_DATA_VARIABLE_LIST,
  SET_ONCHANGE_DATA_CONFIG_QC,
  SET_ONCHANGE_DATA_VARIABLE_LIST_QC,
  SET_CARRIER_SERVICES,
  UPDATE_LAYOUT_DATA,
  SET_FILE_ID,
  DRAG_ITEM_IN_QUICKCREATE,
  SETWINDOWNAME,
  DRAG_ITEM_IN_MOBILEVIEW,
  DETAILVIEW_DRAG,
  DETAILVIEW_REMOVE,
  SELECTORUNSELECT,
} from "../actionTypes/formBuilderTypes";

export const setWindowName=(payload)=>{
  return{
       type:SETWINDOWNAME,
       payload:payload
  }
}
export const selectOrUnselect=(payload)=>{
  return{
    type:SELECTORUNSELECT,
    payload:payload
  }
}
export const setLayoutFieldCountAction = (modType,payload) => {
  return { 
    modType:modType,
    type: LAYOUT_FIELD_COUNT,
    payload:payload
  };
};

export const clearFieldGroups = (modType) =>{
  return {
    modType : modType,
    type : CLEAR_FIELD_GROUPS,
    payload :[]
  };
}

export const setEmailConfigList =(emailConfig)=>{
  return{
    type:SET_EMAIL_CONFIG_LIST,
    payload:emailConfig
  }
}

export const setUserSelectedList = (userSelectedList) => {
  return {
    type: SET_USER_SELECTED_LIST,
    payload: userSelectedList
  }
}

export const addItemAction = (element,dragIndex, hoverIndex,sectionId='') => {
  ;
  const id = "";//uuidv4();
  const props = addPropsToItem(element);
  const item = { id, element, ...props };
  return { 
    type: ADD_ITEM_TO_PREVIEW, 
    modType:'LAYOUT', 
    payload:{
      item:{...item,isUnused:true},
      dragIndex:dragIndex,
      hoverIndex:hoverIndex,
      sectionId:sectionId
    }
  };
};

export const addItemToQuickCreateAction = (sectionIndex,fieldIndex,addedIndex)=>{
  // const item = { sectionIndex, fieldIndex, addedIndex};
  return { 
    type: ADD_REMOVE_ITEM_TO_QUICK_CREATE,
    modType:'LAYOUT', 
    payload: {
      sectionIndex:sectionIndex,
      fieldIndex:fieldIndex,
      addedIndex:addedIndex,
      bool:true
    } 
  };
}
export const removeItemFromQuickCreateAction = (sectionIndex,fieldIndex)=>{
  // const item = { sectionIndex, fieldIndex};
  return { 
    type: ADD_REMOVE_ITEM_TO_QUICK_CREATE, 
    modType:'LAYOUT',
    payload: {
      sectionIndex:sectionIndex,
      fieldIndex:fieldIndex,
      bool:false
    }  
  };
}

export const addItemToMobileViewAction = (sectionIndex,fieldIndex,addedIndex)=>{
  // const item = { sectionIndex, fieldIndex, addedIndex};
  return { 
    type: ADD_REMOVE_ITEM_TO_MOBILE_VIEW,
    modType:'LAYOUT', 
    payload: {
      sectionIndex:sectionIndex,
      fieldIndex:fieldIndex,
      addedIndex:addedIndex,
      bool:true
    } 
  };
}
export const removeItemFromMobileViewAction = (sectionIndex,fieldIndex)=>{
  // const item = { sectionIndex, fieldIndex};
  return { 
    type: ADD_REMOVE_ITEM_TO_MOBILE_VIEW, 
    modType:'LAYOUT',
    payload: {
      sectionIndex:sectionIndex,
      fieldIndex:fieldIndex,
      bool:false
    }  
  };
}
export const  layoutSettingsAction=(type,settingObj) =>{
  return { 
    modType:'LAYOUT',
    type: LAYOUT_SETTINGS,
    payload: { 
      settingObj,
      type 
    } 
  };
}
export const setCurrentContentAction =(id) =>{
  return { 
    modType:'LAYOUT',
    type: SET_FORM_CONTENT,
    payload: { 
      id 
    } 
  };
}

export const updateSectionContentTitleAction =(title) =>{
  return { 
    modType:'LAYOUT',
    type: UPDATE_SECTION_HEAD,
    payload: {
      title 
    } 
  };
}
export const layoutNameOnChangeHandlerAction =(e) =>{
  const layoutName = e.target.value;
  return { 
    modType:'LAYOUT',
    type: UPDATE_LAYOUT_ONCHANGE,
    payload: {
      layoutName 
    } 
  };
}

export const removeSectionContentAction =(id) =>{
  // console.log(id);
  return { 
    modType:'LAYOUT',
    type: REMOVE_SECTION,
    payload: {
      id 
    } 
  };
}

export const addNewFormAction = () => {
  return { 
    modType:'LAYOUT',
    type: ADD_FORM_TO_PREVIEW
  };
};
export const addNewSectionAction = () => {
  return { 
    modType:'LAYOUT',
    type: ADD_SECTION_TO_PREVIEW
  };
};


export const removeItemAction = (sectionIndex,fieldIndex) => (
  { 
    modType:'LAYOUT',
    type: REMOVE_ITEM_FROM_PREVIEW, 
    payload: { 
      sectionIndex:sectionIndex,
      fieldIndex:fieldIndex,
    } 
  }
);


export const dragContentAction = (dragContentIndex, hoverContentIndex,sectionId) => {
  return { 
    modType:'LAYOUT',
    type: DRAG_CONTENT_IN_PREVIEW, 
    payload: { 
      dragContentIndex, 
      hoverContentIndex,
      sectionId 
    } 
  }
};
export const dragItemAction = (dragIndex, hoverIndex,sectionId) => {
  // console.log(dragIndex, hoverIndex,sectionId);
  return { 
    type: DRAG_ITEM_IN_PREVIEW, 
    modType:'LAYOUT',
    payload: { 
      dragIndex:dragIndex, 
      hoverIndex:hoverIndex,
      sectionId:sectionId
    } 
  }
};
export const QuickCreatedragItemAction = (dragIndex, hoverIndex,sectionId) => {
  // console.log(dragIndex, hoverIndex,sectionId);
  return { 
    type: DRAG_ITEM_IN_QUICKCREATE, 
    modType:'LAYOUT',
    payload: { 
      dragIndex:dragIndex, 
      hoverIndex:hoverIndex,
      sectionId:sectionId
    } 
  }
};
export const MobileViewdragItemAction= (dragIndex, hoverIndex,sectionId) => {
  return { 
    type: DRAG_ITEM_IN_MOBILEVIEW, 
    modType:'LAYOUT',
    payload: { 
      dragIndex:dragIndex, 
      hoverIndex:hoverIndex,
      sectionId:sectionId
    } 
  }
};
export const showEditorAction = (item,index) => {
  return{ 
    type: SHOW_EDITOR, 
    modType:'LAYOUT',
    payload: { 
      item,
      index 
    } 
  }
};

export const hideEditorAction = () => (
  { 
    type: HIDE_EDITOR,
    modType:'LAYOUT', 
  }
);

export const submitEditorStateAction = (editState) => {
  return{ 
    type: SUBMIT_EDITOR_STATE, 
    modType:'LAYOUT',
    payload: { 
      editState 
    } 
  }
};
export const addFormFieldValidationAction = (state)=>{
  return null;
}

export const changeLayoutColumnAction = (section_index,column) =>{
  // alert('sdfds');
  return {
    type: LAYOUT_COLUMN_CHANGE,
    modType:'LAYOUT', 
    payload: { 
      section_index:section_index,
      column_type:column 
    } 
  }
}

export const  setLayoutDataActions = (modType,layoutObject,fieldGroups,nonFieldGroups) =>{
  
  if(modType==='LAYOUT' && fieldGroups.length===0){
    fieldGroups = [{
      type:"section",
      title:"HEADING",
      column_type:"single",
      section_index:0,
      data:[]
    }]
  }
  return {
    type:SET_LAYOUT_DATA,
    modType:modType,
    payload: { 
      layoutObjectData:layoutObject,
      fieldGroupsData:fieldGroups,
      nonFieldGroupsData:nonFieldGroups 
    } 
  }
}

export const  setLayoutDataWithSubFormAction = (modType,layoutObject,fieldGroups,nonFieldGroups,subFormData) =>{
  
  if(modType==='LAYOUT' && fieldGroups.length===0){
    fieldGroups = [{
      type:"section",
      title:"HEADING",
      column_type:"single",
      section_index:0,
      data:[]
    }]
  }
  return {
    type:SET_LAYOUT_DATA_SUBFORM,
    modType:modType,
    payload: { 
      layoutObjectData1:layoutObject,
      fieldGroupsData1:fieldGroups,
      nonFieldGroupsData1:nonFieldGroups,
      subFormData1:subFormData
    } 
  }
}
export const  updateFormFieldValidationAction = (modType,fieldId,message) =>{
  return {
    modType:modType,
    type:UPDATE_FORM_FIELD_VALIDATION,
    payload: { 
      fieldId:fieldId,
      message:message
    } 
  }
}
export const  clearFormFieldValidationAction = (modType,itemId) =>{
  return {
    modType:modType,
    type:CLEAR_FORM_FIELD_VALIDATION,
    payload: { 
      clear:true
    } 
  }
}

export const setSelectedMultiLookupAction = (selectedArr,itemId) =>{
  // console.log(selectedArr);
  return {
    modType:'LAYOUT',
    type:SET_SELECTED_MULTILOOKUP,
    payload: { 
      selectedArr:selectedArr,
      mLookupFieldId:itemId
    } 
  }
}
export const addSelectedMultiLookupAction = (selectedRows,itemId) =>{
  return {
    modType:'LAYOUT',
    type:ADD_SELECTED_MULTILOOKUP,
    payload: { 
      selectedRows:selectedRows,
      mLookupFieldId:itemId
    } 
  }
}

export const removeSelectedMultiLookupAction = (selectedRowsId,itemId) =>{
  return {
    modType:'LAYOUT',
    type:REMOVE_SELECTED_MULTILOOKUP,
    payload: { 
      selectedRowsId:selectedRowsId,
      mLookupFieldId:itemId
    } 
  }
}

export const addDetailViewAction = (object) =>{
  return {
    modType:'LAYOUT',
    type:DETAILVIEW_ADD,
    payload:{
      ...object.payload,
      addedIndex:object.addedIndex,
      bool:true,
    }
  }
}
export const dragDetailViewAction = (object) =>{
  return {
    modType:'LAYOUT',
    type:DETAILVIEW_DRAG,
    payload: { 
      dragIndex:object.removedIndex, 
      hoverIndex:object.addedIndex,
    } 
  }
}

export const removeDetailViewAction = (itemIndex,field) =>{
  return {
    modType:'LAYOUT',
    type:DETAILVIEW_REMOVE,
    payload:{
      bool:false,
      // sectionIndex:sectionIndex,
      itemIndex:itemIndex,
      isNonFieldGroups:field.isNonFieldGroups
    }
  }
}

export const typeChangeHandlerAction = (itemIndex,type,field) =>{
  return {
    modType:'LAYOUT',
    type:DETAILVIEW_TYPE_HANDLER,
    payload:{
      itemIndex:itemIndex,
      tabType:type,
      isNonFieldGroups:field.isNonFieldGroups
    }
  }
}


export const sortingDetailViewAction = (selectedRows,itemId) =>{
  return {
    modType:'LAYOUT',
    type:DETAILVIEW_SORTING,
    payload: { 
      selectedRows:selectedRows
    } 
  }
}

export const fieldPermissionChangeHandlerAction = (payload)=>{
  return {
    modType:'LAYOUT',
    type:FIELD_PERMISSION_ONCHANGE,
    payload: { 
      ...payload
    } 
  }
}
export const setValidationRulesAction = (modType,payload)=>{
  return {
    // modType:'LAYOUT',
    modType:modType,
    type:SET_VALIDATION_RULES,
    payload: { 
      ...payload
    } 
  }
}

export const setLayoutRulesAction = (modType,payload)=>{
  return {
    // modType:'LAYOUT',
    modType:modType,
    type:SET_LAYOUT_RULES,
    payload:payload
  }
}


export const setRulesMappingAction = (modType,payload)=>{
  return {
    // modType:'LAYOUT',
    modType:modType,
    type:SET_RULES_MAPPING,
    payload:{
      rulesMappingObj:payload
    }
  }
}

export const setLookupDependencyAction = (payload)=>{
  return {
    modType:'LAYOUT',
    type:SET_LOOKUP_DEPENDENCY,
    payload: { 
      ...payload
    } 
  }
}

export const clearSelectedMultiLookupAction = () =>{
  return {
    modType:'LAYOUT',
    type:CLEAR_SELECTED_MULTILOOKUP,
    payload: { 
      clear:true
    } 
  }
}
export const dropDownFieldMappingAction = (updateData,dependencyMap) =>{
  return {
    modType:updateData.item.modType,
    type:DROPDOWN_FIELD_MAPPING,
    payload: { 
      mappingObj:updateData,
      dependencyMap:dependencyMap
    } 
  }
}
export const setSubFormDataAction = (modType,updateData) =>{
  return {
    modType:modType,
    type:SET_SUBFORM_DATA,
    payload: updateData
  }
}

export const updateSubFormDataAction = (modType,updateData) =>{
  return {
    modType:modType,
    type:UPDATE_SUBFORM_DATA,
    payload: updateData
  }
}

export const setSectionFieldsAction = (modType,payload)=>{
  return{
    modType:modType,
    type:ADD_COPY_SECTION_TO_LAYOUT,
    payload:payload
  }
}

export const onChangeStatusAction = (updateJSON,value,fieldType)=>{
  return {
    modType:'DETAILVIEW',
    type:UPDATE_DETAIL_VIEW_STATUS,
    payload: {
      statusObj:updateJSON,
      fieldType:fieldType,
      value:value
    }
  }
}

export const masterDetailWindowAction = (masterDetailData)=>{
  return {
    modType:'LAYOUT',
    type:MASTER_WINDOW_LIST_ACTION,
    payload: { 
      masterDetailData:masterDetailData
    } 
  }
}
export const updateActionButtonAction = (obj)=>{
  const {params,actionComponents,actionBtn,layout_type,layout_details,html_code,show_territory,max_territories} = obj;
  // console.log('layout_details',params);
  return{
    modType:'LAYOUT',
    type:UPDATE_ACTION_BUTTON,
    payload:{
      status:200,
      windowId:params.windowId,
      layoutId:params.layoutId,
      actionComponents:actionComponents,
      layout_details:layout_details,
      buttons:actionBtn,
      layout_type:layout_type,
      html_code:html_code,
      show_territory:show_territory,
      max_territories:max_territories
    }
      
  }
}
export const modifyActionButtonsAction = (obj)=>{
  const {params,actionObj,actionComponents,layout_details} = obj;
  // console.log(obj);
  return dispatch => {
    const actionBtn = placeActionButtons({
      components:actionComponents,
      params:params,
      layout_details,
      ...actionObj
    });
    dispatch(updateActionButtonAction({...obj,actionBtn:actionBtn}));
  }
}
  export const setActionButtonsAction = (params, actionObj) => {
    return async (dispatch) => {
      const page = 0; 
      const orderBy = '';
      const perPage = 2; 
      const direction = 'ASC'; 
      const search = '';
      const gridFilter = {};
      const isGridview = '';
      const queryString = `?listCall=true&query=${search}&page=${page}&orderBy=${orderBy}&size=${perPage}&direction=${direction}&kanbanView=${isGridview}`;
  
      try {
        const layoutScopedUrl = `component-actions/window/${params.windowId}/layout/${params.layoutId}`;
        const [layoutRes, listRes] = await Promise.all([
          callGET(layoutScopedUrl),
          callPOST(`table-data-engine/${params.windowName}/metatable/record-list${queryString}`, gridFilter),
        ]);

        let actionComponents = [];
        let layout_type = null;
        let layout_details = {};
        let html_code = null;
        let show_territory = false;
        let max_territories = 0;

        if (listRes.status === 200 && listRes.data?.code === 200) {
          ({
            layout_type,
            layout_details,
            html_code,
            show_territory,
            max_territories,
          } = listRes.data.data);
        }

        if (layoutRes.status === 200 && layoutRes.data?.code === 200) {
          actionComponents = layoutRes.data.data || [];
        } else if (listRes.status === 200 && listRes.data?.code === 200) {
          actionComponents = listRes.data.data.actionComponents || [];
        }

        if (actionComponents.length > 0 || (listRes.status === 200 && listRes.data?.code === 200)) {
          const actionBtn = placeActionButtons({
            components: actionComponents,
            params: params,
            layout_details,
            ...actionObj,
          });
          dispatch(updateActionButtonAction({
            params,
            actionComponents,
            actionBtn,
            layout_type,
            layout_details,
            html_code,
            show_territory,
            max_territories,
          }));
        }
      } catch (error) {
        console.log(error);
      }
    };
  };
  //   export const setActionButtonsAction = (params, actionObj) => {
  // return dispatch => {
  //     const page = 0; 
  //     const orderBy = '';
  //     const perPage = 2; 
  //     const direction = 'ASC'; 
  //     const search = '';
  //     const gridFilter = {};
  //     const isGridview = '';
  //     const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction+'&kanbanView='+isGridview;
  //     callPOST('table-data-engine/'+params.windowName+'/metatable/record-list'+queryString,gridFilter)
  //     .then(res => {
  //       if(res.status===200){ 
  //         const response = res.data;
  //         if(response.code===200){
  //           // console.log('response.data',response.data);
  //             const actionComponents = response.data.actionComponents;
  //             const layout_type = response.data.layout_type;
  //             const layout_details = response.data.layout_details;
  //             const html_code = response.data.html_code;
  //             const show_territory = response.data.show_territory;
  //             const max_territories = response.data.max_territories;
  //             const actionBtn = placeActionButtons({
  //               components:actionComponents,
  //               params:params,
  //               ...actionObj
  //             });
  //             dispatch(updateActionButtonAction({actionComponents,actionBtn,layout_type,layout_details,html_code,show_territory,max_territories}));
  //         }
  //       }
  //     },(error) => {
  //         console.log(error);
  //   })
  // }
// }

export const onBlurHandlerAction =(updateData,fieldValue)=>{
  return {
    modType:updateData.modType,
    type:HANDLE_INPUT_BLUR,
    payload: { 
      fieldObj:updateData,
      value:fieldValue,
    } 
  }

}

export const  onChangeInputAction = (updateData,e,inputType='text') =>{
  let fieldValue;
  if(inputType==='PickList'){
    fieldValue = e;
  }else if(inputType==='CheckBoxes'){
    fieldValue = e.target.checked;
  }else if(inputType==='MultiSelect'){
    let MultiSelectValue = [];
    e = (e===null)?[]:e;
    e.map((item)=>{
      MultiSelectValue.push(item.id);
      return item;
    }); 
    fieldValue = MultiSelectValue.join(',');
  }else if(inputType==='Lookup'){
    fieldValue = e;
  }else if(inputType==='number'){
    fieldValue = e; 
  }else if(inputType==='MultiLookup'){
    fieldValue = e; 
  }else if(inputType==='date'){
    fieldValue = e;
  }else if(inputType==='Files'){
    fieldValue = e;
  }else if(inputType==='Reminder'){
    fieldValue = e;
  }else if(inputType==='currencyType'){
    fieldValue = e;
  }else if(inputType==='exchangeRate'){
    fieldValue = e;
  }else if(inputType==='phoneNumber'){
    fieldValue = e;
  }else if(inputType==='CustomAllSingle'){
    fieldValue = e;
  }else if(inputType==='CustomAllArray'){
    let MultiArrayValue = [];
    e = (e===null)?[]:e;
    e.map((item)=>{
      MultiArrayValue.push(item.id);
      return item;
    }); 
    fieldValue = MultiArrayValue.join(',');
  }else if(e){
    fieldValue = e.target.value;
  }
  return {
    modType:updateData.item.modType,
    type:HANDLE_INPUT_CHANGE,
    payload: { 
      fieldObj:updateData,
      value:fieldValue,
      inputType:inputType
    } 
  }
}

export const setAddedTagsAction = (data)=>{
  return{
    type:SET_MAPPING_TAGS,
    payload:{
      tags:data
    }
  }
}
export const copyFromLayoutAction = (data)=>{
  // console.log(data)
  // const item = { sectionIndex, fieldIndex, addedIndex};
  return { 
    type: COPY_LAYOUT_FIELD_GROUPS,
    payload: {
      copyFieldGroupsData : data
    }
  };
}


export const updateSubformFieldValidationAction = (modType,fieldId,subform_row,message) =>{
    // console.log("updateSubformFieldValidationAction","modType,fieldId,subform_row,message",modType,fieldId,subform_row,message);
    return {
      modType :modType,
      type:UPDATE_SUBFORM_FIELD_VALIDATION,
      payload: {
        fieldId:fieldId,
        subform_row : subform_row,
        message:message
      }
    }
  }
  export const clearSubformValidation = (modType,row)=>{
    return {
      modType : modType,
      type:CLEAR_SUBFORM_FIELD_VALIDATION,
      payload :{
        subform_row:row
      }
    }
  }

export const addInprogressStepExecution =(jobId,data)=>{
  return{
    type:ADD_INPROGRESS_STEP_EXECUTION,
    payload: {
      data:data,
      jobId:jobId
    }
  }
}

export const removeInprogressStepExecution =(jobId)=>{
  return{
    type:REMOVE_INPROGRESS_STEP_EXECUTION,
    payload:jobId
  }  
}

export const setOnloadConfigDataAction =(payload)=>{
  return{
    type:SET_ONLOAD_DATA_CONFIG,
    payload:payload
  }  
}
export const setOnChangeConfigDataAction =(payload)=>{
  return{
    type:SET_ONCHANGE_DATA_CONFIG,
    payload:payload
  }  
}

export const setOnChangeConfigVariableListAction =(payload)=>{
  return{
    type:SET_ONCHANGE_DATA_VARIABLE_LIST,
    payload:payload
  }  
}


export const setOnChangeConfigDataQCAction =(payload)=>{
  return{
    type:SET_ONCHANGE_DATA_CONFIG_QC,
    payload:payload
  }  
}

export const setOnChangeConfigVariableListQCAction =(payload)=>{
  return{
    type:SET_ONCHANGE_DATA_VARIABLE_LIST_QC,
    payload:payload
  }  
}


export const updateSectionSortByAction =(sortBy) =>{
  return { 
    modType:'LAYOUT',
    type: UPDATE_SECTION_SORT_BY,
    payload: {
      sortBy 
    } 
  };
}

export const sortByChangeHandlerAction = (sectionIndex,sortBy) =>{
  return {
    modType:'LAYOUT',
    type:DETAILVIEW_SORT_BY_HANDLER,
    payload:{
      sectionIndex:sectionIndex,
      sortBy,
    }
  }
}


//MYSHIP-HARDCODE
export const setCarrierServicesList =(payload)=>{
  return {
    type:SET_CARRIER_SERVICES,
    payload:payload
  }  
}

export const updateLayoutData = (fieldGroup,id,modType) =>{
  return  {
    type:UPDATE_LAYOUT_DATA,
    modType:modType,
    payload:{
      lookupData:fieldGroup,
      field_id :id
    }
  }
}

export const setFileId = (payload)=>{
  return {
    type:SET_FILE_ID,
    payload:payload
  }  
}